<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg141"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs145"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath155"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path153" /></clipPath></defs><g
     id="g147"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g149"><g
         id="g151"
         clip-path="url(#clipPath155)"><g
           id="g157"
           transform="translate(62.4766,208.397)"><path
             d="m 0,0 -54.684,152.013 c -0.939,2.649 0.456,5.582 3.105,6.55 28.936,10.394 59.126,20.561 89.601,30.812 M 328.043,-107.73 153.341,-170.523 76.67,-198.089 c -2.648,-0.969 -5.582,0.427 -6.55,3.075 L 11.506,-31.98"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path159" /></g><g
           id="g161"
           transform="translate(425.0669,106.5903)"><path
             d="m 0,0 -181.423,-31.098 -80.317,-13.783 c -2.762,-0.455 -5.439,1.424 -5.924,4.187 l -29.648,173 -32.668,190.458 c -0.484,2.79 1.396,5.439 4.158,5.923 l 91.538,15.691"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path163" /></g><g
           id="g165"
           transform="translate(190.7827,295.0542)"><path
             d="m 0,0 v 201.621 c 0,2.933 2.393,5.325 5.326,5.325 h 238.129 3.987 c 1.623,0 2.079,-0.655 4.842,-3.275 l 58.414,-55.702 c 2.364,-2.307 3.019,-2.563 3.019,-4.101 v -3.303 -237.645 -86.03 c 0,-2.933 -2.392,-5.354 -5.325,-5.354 H 90.342 5.326 c -2.933,0 -5.326,2.421 -5.326,5.354 v 148.311"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path167" /></g><g
           id="g169"
           transform="translate(434.2378,502)"><path
             d="m 0,0 0.114,-52.826 c 0,-11.818 10.823,-11.077 16.034,-11.077 h 54.114"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path171" /></g><g
           id="g173"
           transform="translate(456.3672,393.0449)"><path
             d="M 0,0 H -214.433"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path175" /></g><g
           id="g177"
           transform="translate(456.3672,339.7637)"><path
             d="M 0,0 H -214.433"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path179" /></g><g
           id="g181"
           transform="translate(456.3672,286.4824)"><path
             d="M 0,0 H -214.433"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path183" /></g><g
           id="g185"
           transform="translate(456.3672,233.2012)"><path
             d="M 0,0 H -214.433"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path187" /></g><g
           id="g189"
           transform="translate(456.3672,179.9194)"><path
             d="M 0,0 H -214.433"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path191" /></g></g></g></g></svg>
</template>
